import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  ExtendedFlex,
  Body,
  Image,
  Heading,
} from '../coreui';

const firstAnimation = 'firstTimeLine';
const secondAnimation = 'secondTimeLine';

const Container = ({
  firstPosition,
  ...props
}) => <ExtendedFlex {...props} />;

const StyledContainer = styled(Container)`
  &::before {
    content: '';
    position: absolute;
    bottom: 7px;
    width: 0;
    height: 0;
    border-style: solid;
    top: 15px;
  }

  ${({ firstPosition }) => {
    if (firstPosition) {
      return {
        '&::before': {
          right: '-16px',
          borderWidth: '8px 0 8px 16px',
          borderColor: 'transparent transparent transparent #FFFFFF',
        },
      };
    }

    return {
      '&::before': {
        left: '-24px',
        borderWidth: '8px 16px 8px 8px',
        borderColor: 'transparent #FFFFFF transparent transparent',
      },
    };
  }}
`;

class TimelineCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: undefined,
      animationName: undefined,
    };
  }

  static getDerivedStateFromProps(props, state) {
    // If we've already been visible, we don't want to do the animation again.
    const isVisible = state.isVisible || props.isVisible;

    // If state says we've already become visible, lock the animation to prevent
    // it from running again.
    const name = state.isVisible ? state.animationName : (() => {
      let animationName = (props.position === 'second' && secondAnimation) || firstAnimation;

      // Check if we're a mobile size. This is really just to make the animation
      // slightly better UX, so it doesn't really impact the user if it doesn't get
      // it 100% correct.
      if (props.position !== 'second' && (typeof window !== 'undefined' || typeof document !== 'undefined') && (window.innerWidth || document.documentElement.clientWidth) < 832) {
        animationName = secondAnimation;
      }
      return animationName;
    })();

    return {
      animationName: name,
      isVisible,
    };
  }

  render() {
    const {
      position,
      icon,
      heading,
      body: bodyProp,
      children,
      isVisible,
      ...props
    } = this.props;

    const body = bodyProp && !Array.isArray(bodyProp) ? [bodyProp] : bodyProp;

    const {
      animationName,
    } = this.state;

    const animationProps = isVisible ? {
      animationName,
      duration: '1s',
      fillMode: 'backwards',
      delay: '0s',
    } : {};

    return (
      <StyledContainer
        position="relative"
        flexDirection="column"
        align="center"
        bg="white"
        m={40}
        w={[250, 350, null, 450, 480]}
        maxWidth={['60vw', null, '35vw', null, '100%']}
        p={20}
        zIndex={2}
        firstPosition={animationName === firstAnimation}
        {...props}
        {...animationProps}
      >
        {
          icon &&
          <Image
            src={icon}
          />
        }
        {
          heading &&
          <Heading
            type="H5.1"
            textAlign="center"
          >
            {heading}
          </Heading>
        }
        {
          body &&
          body.map(item => (
            <Body
              type="B1"
              textAlign="center"
              w={1}
              key={item}
            >
              {item}
            </Body>
          ))
        }
        {children}
      </StyledContainer>
    );
  }
}

TimelineCard.propTypes = {
  isVisible: PropTypes.bool,
  position: PropTypes.oneOf([
    'first',
    'second',
  ]),
  icon: PropTypes.string,
  heading: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.object,
};

export default TimelineCard;
